setTimeout(() => {
  
  jQuery(document).ready(function($) {
    $('.yottie-container a').last().attr('style','display:none');
    $('.header-icons__search').before('<a class="gallery_btn" href="/pages/gallery">GALLERY</a>');
    $('.drawer-menu').append('<li><a class="gallery_btn" href="/pages/gallery">GALLERY</a></li>');
    $('.eapps-instagram-feed.es-widget.eapps-widget.eapps-widget-show-toolbar >a').hide();
    
    $('.eapps-widget.eapps-widget-show-toolbar .yottie-container >a').hide();
    $('.eapps-instagram-feed.es-widget > a').attr('style','display:none');
    $('.section-vertical-spacer.container.container--capped > div > .yottie-container > a').attr('style','display:none');
    
    
    let isCollections = window.location.href.includes('/collections/products');
    let isAcademy = window.location.href.includes('/pages/academy');
    let hasVideoFixer = $('.video-fixer').length;

    let removeFreeLink = () => {
      if ($('#eapps-instagram-feed-1').length > 0) {
        $('#shopify-section-template--23083291181331__custom_liquid_xRNxk7 > div > div > div > div > a').remove();
      }
    };
    
    // Use setInterval to repeatedly check
    const intervalId = setInterval(() => {
      removeFreeLink();
    }, 600);
    
    // Optional: Clear the interval once the link is removed (to avoid unnecessary checks)
    let removeFreeLinkOnce = () => {
      if ($('#eapps-instagram-feed-1').length > 0) {
        const targetLink = $('#shopify-section-template--23083291181331__custom_liquid_xRNxk7 > div > div > div > div > a');
        if (targetLink.length > 0) {
          targetLink.remove();
          clearInterval(intervalId); // Stop further execution
        }
      }
    };
    
    // Replace the interval logic if you want to remove it only once
    const intervalIdOnce = setInterval(() => {
      removeFreeLinkOnce();
    }, 600);
  
    let priceFilter = () => {
      $('.min--val').on('input', function() {
          $('.before--slider').text(`${$(this).val()}$`);
      })
      $('.max--val').on('input', function() {
          $('.after--slider').text(`${$(this).val()}$`);
      })
  
      $('.max--val, .min--val').change(function() {
        setTimeout(() => {
          priceFilter();
          filterFunc();
        }, 600)
      })
    }
  
    let filterFunc = () => {
      function getProductTypeFromQueryString() {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          return urlParams.get('filter.p.product_type');
      }
    
      let activeFilter = getProductTypeFromQueryString();
  
      if(activeFilter == null) {
        $('.all__filter').addClass('active');
      }
      
      $('.cat-filters ul li').each(function() {
        let filter = $(this).find('a').text().trim();
        if(filter == activeFilter) {
          $(this).addClass('active');
        }
      })
    }
  
    setTimeout(() => {
      filterFunc();
      priceFilter();
    }, 600)

    // Blog slider
    if(isAcademy) {
      let blogData = [];
      
      var swiper = new Swiper('.swiper', {
          slidesPerView: 1, // Show one slide per view
          spaceBetween: 30, // Space between slides
          loop: true, // Enable loop mode
          // Navigation arrows
          navigation: {
              nextEl: '.treegers-next-btn',
              prevEl: '.treegers-prev-btn',
          },
      });
    }
    
    // Video border fix
    if(hasVideoFixer) {
  
      var width = $('.video-fixer .media-with-text__media--fill').width();
      var height = width * (490 / 740);
      $('.video-fixer .media-with-text__media--fill').css('height', height + 'px');
      $('.video-fixer .media-with-text__media--fill').parent().css('height', height + 'px');
      
      $(window).on('resize load', function() {
        var width = $('.video-fixer .media-with-text__media--fill').width();
        var height = width * (490 / 740);
        $('.video-fixer .media-with-text__media--fill').css('height', height + 'px');
        $('.video-fixer .media-with-text__media--fill').parent().css('height', height + 'px');
      });
      
    }
  
    // Added by Shahin
    let spectrumContainer = $('#Scroller-template--19237345329427__142a07e7-3a50-4fb9-8d49-d3bc312823a2 li:first-child .rich-text');
    let stuffToMove = $('#shopify-section-template--19237345329427__collapsible_content_gdUrdp .collapsible-content-list ');
  
    if($(window).width() > 768) {
      stuffToMove.appendTo(spectrumContainer);
    }
    
    // When you click on resources on product pages, it should scroll down to the resource section
    let closeModal = () => {
      $(".resource-modal .close-modal").click(function () {
        $(".resource-modal").fadeOut();
      });
    };
  
    // Conditions
    let singleProduct = $('.main-product__media-gallery__inner').length;
    let hasScrollToSection = $('.treegers-scroll-to-resources').length;
    let hasProductThumbs = $('.main-product-media__thumbnails').length;
    let hasAuthorInfo = $('.testimonial-author-info').length;
    
    let certModal = () => {
      let productTitle = $("h1").text().trim();
      let popupData = [];
    
      $(".has-popup").click(function () {
        popupData = [];
        
        let poppyTitle = $(this).parent().find('h3').text().trim();
        let poppyLinks = $(this).data("popup-links").split(",");
        let poppyAnchors = $(this).data("popup-anchors").split(",");
    
        popupData.push({
          links: poppyLinks,
          anchors: poppyAnchors
        });
    
        console.log(popupData);
    
        $(".resource-modal .data-appender").empty();
        $(".resource-modal .data-appender").append(`
            <h3>${poppyTitle}</h3>
            <div class="cert-container"></div>
        `);
        
        popupData.forEach((data) => {
            data.links.forEach((link, index) => {
                const anchorText = data.anchors[index]; // Get the corresponding anchor text
  
                if(link.includes('pdf')) {
                  $(".resource-modal .data-appender .cert-container").append(`
                      <div class="cert">
                          <img width="15" height="15" src="https://cdn.shopify.com/s/files/1/0764/5288/8851/files/pdf-icon.png?v=1712310964">
                          <a href="${link}" target="_blank">${anchorText}</a> <!-- Use anchorText as link text -->
                      </div>
                  `);
                } else if( link.includes('dropbox') ) {
                  $(".resource-modal .data-appender .cert-container").append(`
                      <div class="cert has-dropbox-link">
                          <img width="15" height="15" src="https://cdn.shopify.com/s/files/1/0764/5288/8851/files/dropbox-icon.png?v=1714442980">
                          <a href="${link}" target="_blank">${anchorText}</a> <!-- Use anchorText as link text -->
                      </div>
                  `);
                } else if( link.includes('s/file') ) {
                  $(".resource-modal .data-appender .cert-container").append(`
                      <div class="cert has-dropbox-link">
                          <img width="15" height="15" src="https://cdn.shopify.com/s/files/1/0764/5288/8851/files/download-solid.svg?v=1731517336">
                          <a href="${link}" target="_blank">${anchorText}</a> <!-- Use anchorText as link text -->
                      </div>
                  `);
                }else {
                  $(".resource-modal .data-appender .cert-container").append(`
                      <div class="cert has-image">
                          <img src="${link}">
                          <a href="${link}" target="_blank">${anchorText}</a> <!-- Use anchorText as link text -->
                      </div>
                  `);
                }
                
            });
        });
    
        $(".resource-modal").fadeIn("slow").css("display", "flex");
      });
    };
  
    let scrollToResources = () => {
      $('.main-product__block-collapsible-tab button').each(function() {
          let tab = $(this);
          let tabText = tab.text().trim();
          let sectionTop = $('.treegers-scroll-to-resources').offset().top;
      
          if(tabText == "Resources") {
              tab.next().remove();
              
              tab.click(function() {
                  $('html, body').scrollTop(sectionTop - 200);
              })
          }
      })
    }
  
    let runButtons = () => {
      let cW = $('.main-product__media-gallery__inner').width();
      $('.main-product__media-gallery__inner').append(`<button class="treegers-prev-next-btn treegers-prev-btn" type="button" title="Previous"><svg aria-hidden="true" width="10" height="10" viewBox="0 0 10 10" style="transform: rotateY(180deg)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.066 8.662a.75.75 0 0 0 1.06 0l4.066-4.066L5.127.53a.75.75 0 1 0-1.061 1.061L7.07 4.596 4.066 7.601a.75.75 0 0 0 0 1.061Z"></path></svg></button>`);
      $('.main-product__media-gallery__inner').append(`<button class="treegers-prev-next-btn treegers-next-btn" type="button" title="Next"><svg aria-hidden="true" width="10" height="10" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.066 8.662a.75.75 0 0 0 1.06 0l4.066-4.066L5.127.53a.75.75 0 1 0-1.061 1.061L7.07 4.596 4.066 7.601a.75.75 0 0 0 0 1.061Z"></path></svg></button>`);
      $('.treegers-next-btn').css('right', `calc(-${cW}px + 100px)`);
  
      $(window).resize(function() {
        cW = $('.main-product__media-gallery__inner').width();
        $('.treegers-next-btn').css('right', `calc(-${cW}px + 100px)`);
      });
  
      $('.treegers-prev-btn').click(function(e) {
          e.stopPropagation();
          $('.main-product-media__thumbnails button[aria-current="true"]').parent().prev().find('button').click();
      })
  
      $('.treegers-next-btn').click(function(e) {
          e.stopPropagation();
          $('.main-product-media__thumbnails button[aria-current="true"]').parent().next().find('button').click();
      })
      
    }
  
    let authorChange = () => {
      $('.testimonial-author-info .caption').text('Treegers');
      $('.testimonial-author .testimonial__image').empty();
      $('.testimonial-author .testimonial__image').append(`<img class="treegers-author-image" src="https://treegers.com/cdn/shop/files/treegers_favicon.png?crop=center&height=32&v=1686935079&width=32">`);
    }
    
    closeModal();
    certModal();
    if(hasScrollToSection) {
      scrollToResources();
    }
    if(singleProduct && hasProductThumbs) {
      runButtons();
    }
  
    if(hasAuthorInfo) {
      authorChange();
    }
  
    let hasAdvantages = $('.section-home-advantages').length;
  
    if(hasAdvantages) {
      $('.section-home-advantages').eq(0).closest('section').css('background','#282625');  
    }

    // Handle weird products
    let hasMeta = $('.card__metadata').length;

    if(hasMeta) {
        $('.card__metadata').each(function() {
            let productTitle = $(this).find('a').text().trim();
            if (productTitle == "TSHIRT TACTICAL GROW WEAR 100% ORGANIC COTTON" || productTitle == "STORAGE TIN") {
                $(this).find('.price-details').hide();
            }
        })
    }

    if(singleProduct) {
      let pT = $('h1').text().trim();

       // Update Currency 
      
      function updateCurrency(getCountry) {
    let currentCountryCode = getCountry;
    
    // Find the button that opens the dropdown
    let dropdownButton = $('button[aria-controls="FooterCountryCurrencyList"]');
    
    // Check if the currently selected country is different from the desired country
    let selectedCountry = $('#FooterCountryCurrencyList ul li a.popover-menu-list__link--active').data('value');
    
    if (selectedCountry !== currentCountryCode) {
        // Find the matching country option
        $('#FooterCountryCurrencyList ul li').each(function(index, data) {
            let listItem = $(data);
            let anchor = listItem.find('a');
            
            // Check if the anchor's data-value matches the current country code
            if (anchor.data('value') === currentCountryCode) {
                // Remove the active class from any previously active link
                $('#FooterCountryCurrencyList ul li a').removeClass('popover-menu-list__link--active');
                
                // Add the active class to the matching anchor
                anchor.addClass('popover-menu-list__link--active');
                
                // Update the button text to reflect the selected country
                let buttonText = anchor.text();
                dropdownButton.html(buttonText + '<span><svg class="icon icon--caret" aria-hidden="true" focusable="false" role="presentation" width="7" height="6" viewBox="0 0 7 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M.293.793a1 1 0 0 0 0 1.414L3.5 5.414l3.207-3.207A1 1 0 0 0 5.293.793L3.5 2.585 1.707.793a1 1 0 0 0-1.414 0Z"></path></svg></span>');
                
                let changeEvent = new Event('change', { bubbles: true });
                anchor[0].dispatchEvent(changeEvent);
                let form = anchor.closest('form');
                if (form) {
                    // Create a hidden input with the country code if needed
                    let hiddenInput = $('<input type="hidden" name="country_code" value="' + currentCountryCode + '">');
                    $(form).append(hiddenInput);
                    
                    // Submit the form programmatically
                    form.submit();
                }
                
                return false; // Break out of the loop
            }
        });
    }
}

      
      
    // Detect Country
$.get("https://ipinfo.io/json", function (response) {
    let country = response.country;
    console.log('Detected country:', country);
    
    // List of EU country codes (you may want to expand this)
    const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
    
    updateCurrency(country);
    
    if(country == "NZ") {
        $('.main-product__block-quantity-selector, .main-product__block-buy-buttons').hide();
        $('.treegers-quantity-wrapper').before(`
            <div class="location-button-wrapper">
                <a href="https://www.easygrow.co.nz/246-treeger-led" target="_blank">New Zealand  - North Island</a>
                <a href="https://www.hydrogarden.co.nz/Search/?search=treegers&sort=" target="_blank">New Zealand - South Island</a>
            </div>
        `);
        
        if(pT == "INTRACANOPY LED FIXTURE" || pT == "TL650W FS GH LED Fixture") {
            $('.location-button-wrapper').attr('style','display:none !important');
        }
    } 
    // Check if country is NOT NZ, NOT AU, and NOT in EU
    else if(country !== "NZ" && country !== "AU" && !euCountries.includes(country)) {
        $('.main-product__block-quantity-selector, .main-product__block-buy-buttons').hide();
        $('.treegers-quantity-wrapper').before(`
            <div class="location-button-wrapper">
                <a href="https://treegers.com/pages/contact">Contact us for International Enquiries</a>
            </div>
        `);

        if(pT == "INTRACANOPY LED FIXTURE" || pT == "TL650W FS GH LED Fixture") {
            $('.location-button-wrapper').attr('style','display:none !important');
        }
    } 
    // For all other cases (including EU countries)
    else {
        $('.main-product__block-quantity-selector, .main-product__block-buy-buttons').fadeIn();
        // Ensure any existing location button is removed
        $('.location-button-wrapper').remove();
    }
}).fail(function() {
    // Fallback in case the geolocation fails
    $('.main-product__block-quantity-selector, .main-product__block-buy-buttons').fadeIn();
});
      

      if(pT == "STORAGE TIN" || pT == "TSHIRT TACTICAL GROW WEAR 100% ORGANIC COTTON" ) {
        $('.main-product__block-price').hide();
        $('.treegers-quantity-wrapper > div:not(.main-product__block-share)').hide();
      }

      if(pT == "INTRACANOPY LED FIXTURE" || pT == "TL650W FS GH LED Fixture") {
        $('.main-product__block-price').hide();
        $('.treegers-quantity-wrapper > div:not(.main-product__block-share)').hide();
        $('.main-product__block-collapsible-tab').after(`<a class="coming-soon-btn" href="javascript:void(0)">Coming Soon!</a>`);
      }
    }

    // Position the lang switcher
    let positionLangSwitcher = () => {
      $('.header-icons').prepend($('#etranslate-language-embedded-selector-theme2'));
      $('#etranslate-language-embedded-selector-theme2').fadeIn();
    }

    setTimeout(() => {
      positionLangSwitcher();
    }, 2000)






    //====================================== 
    //  >> Slider Toggler
    //====================================== 


    let buttonHTML = `<div class="slide_toggle"> 
          <button class="triggers_slider_prev" type="button" title="Previous"><svg class="icon" aria-hidden="true" width="10" height="10" viewBox="0 0 10 10" style="transform: rotateY(180deg)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.066 8.662a.75.75 0 0 0 1.06 0l4.066-4.066L5.127.53a.75.75 0 1 0-1.061 1.061L7.07 4.596 4.066 7.601a.75.75 0 0 0 0 1.061Z"></path></svg></button>
          <button class="triggers_slider_next" type="button" title="Next" style="right: calc(-603.5px);"><svg class="icon" aria-hidden="true" width="10" height="10" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.066 8.662a.75.75 0 0 0 1.06 0l4.066-4.066L5.127.53a.75.75 0 1 0-1.061 1.061L7.07 4.596 4.066 7.601a.75.75 0 0 0 0 1.061Z"></path></svg></button>
        </div>`

    function addSliderToggler(ulIDName,top) {
        let ulElement = $(`${ulIDName}`);
        let currentSlideIndex = 0;
        let totalSlides = ulElement.find('li').length;
        let slideWidth = $(window).width() - 32;
      
        ulElement.before(buttonHTML)

        ulElement.parent().find('loess-slider-autoplay-progress.slider__controls').css('display','none')
        ulElement.css('touch-action','pan-y')
        ulElement.find('li').css('transition','.3s')
        ulElement.parent().find('.scroller-bar').hide()
        ulElement.parent().find('.slide_toggle').css('top',`${top}`)
      
        ulElement.parent().find('.slide_toggle button').click(function() {
            console.log('Button clicked');
            let selectedButton = $(this).attr('class');
            if (selectedButton === 'triggers_slider_prev') { 
                triggerRight();
            } else {
                triggerLeft();
            }
        });
    
        function triggerLeft() {
            if (currentSlideIndex < totalSlides - 1) {
                currentSlideIndex++;
                ulElement.find('li').each(function() {
                    let currentTransform = $(this).css('transform');
                    let currentTranslateX = parseCurrentTransform(currentTransform);
                    let newTranslateX = currentTranslateX - slideWidth;
                    $(this).css('transform', `translateX(${newTranslateX}px)`);
                });
            }
        }
        
        function triggerRight() {
            if (currentSlideIndex > 0) {
                currentSlideIndex--;
                ulElement.find('li').each(function() {
                    let currentTransform = $(this).css('transform');
                    let currentTranslateX = parseCurrentTransform(currentTransform);
                    let newTranslateX = Math.min(0, currentTranslateX + slideWidth);
                    $(this).css('transform', `translateX(${newTranslateX}px)`);
                });
            }
        }
        
        function parseCurrentTransform(transform) {
            if (transform === 'none') {
                return 0;
            }
            let values = transform.split('(')[1].split(')')[0].split(',');
            return parseFloat(values[4]);
        }
    }
    
    // // Call the function with just the ID name, without '#' and put top value 
    addSliderToggler('.home_middle_slider' ,'30%');
    // addSliderToggler('.custom-text-slider-home','4%');
    // addSliderToggler('#Scroller-template--19237345329427__blog-posts','88%');
    addSliderToggler('#SliderMobile-template--20026891829523__slideshow_qVrUdn','96.5%');
 
    // // IN Product Page

    // addSliderToggler('.product-resources .scroller-mobile','68%');
    // addSliderToggler('.product-resources.scroller-mobile','68%');
    // // addSliderToggler('.related-products','68%');
    // addSliderToggler('.custom-text-slider','100%');






    // slider section modification
    $('#Scroller-template--19237345329427__142a07e7-3a50-4fb9-8d49-d3bc312823a2 li').eq(0).append($('#shopify-section-template--19237345329427__collapsible_content_gdUrdp'))



    //====================================== 
    //  >> Slider Toggler For distribution page
    //====================================== 
    $('.distribution-item').each(function() {
      var $item = $(this);
      var $companyName = $item.find('.company_name');
      var $additionalInfo = $item.find('.additional-info');
      var $arrow = $item.find('.arrow');

      $companyName.click(function(event) {
        event.preventDefault();
        $additionalInfo.stop(true, true).slideToggle(300);
        $arrow.toggleClass('rotated');
      });
    });

    //====================================== 
    //  >> Cookie consent refused
    //====================================== 
    let videoSrc = window.videoSrc
    if(window.getCkyConsent && !(videoSrc === undefined) && false){
      let consent = window.getCkyConsent();
    
      document.addEventListener('cookieyes_consent_update',function (event) {
        if(consent.categories.functional) return;
        replaceVideo(document.querySelectorAll('#small-video')); 
      });
    }
})

}, 1000);

function replaceVideo(videos) {


  for(var i=0;i<videos.length;i++){
      let video = document.createElement('video');
      let src = document.createElement('source');

    
      video.setAttribute('autoplay',"")
      video.setAttribute('muted',"")
      video.setAttribute('loop',"")
    
      src.setAttribute('src', `https:${videoSrc[i]}`);
      src.setAttribute('type', 'video/mp4');
      video.appendChild(src);
      videos[i].replaceChild(video, videos[i].querySelector('loess-video'));
      if(videos[i].querySelector('img')){
        videos[i].removeChild(videos[i].querySelector('img'))
      }
    }
}

document.addEventListener('DOMContentLoaded', function() {
  // Select all buttons using their specific classes
  var buttons = document.querySelectorAll('.button.button--secondary.button--color-overriden.tap, .button.button--primary.button--color-overriden.tap');
  
  buttons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent the default behavior (navigation)
      var url = button.getAttribute('href'); // Get the URL from the href attribute
      window.open(url, '_blank'); // Open the link in a new tab
    });
  });
});



